import {MDIcon, MDIconSize} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {MenuItem} from '@mintdata-wsp/wsp/ui/components/menus/MenuItem';
import {AMenuItemRenderer} from '@mintdata-wsp/wsp/ui/views/visualDesigner/general/menus/MainMenu';
import {IListItemState} from '@mintdata/mint-kit/api/models/List';
import {ContextMenu, IContextMenuItem, ToggleOn} from '@mintdata/mint-kit/impl/components/contextMenu/ContextMenu';
import {PopupAnchor, SourceAnchor} from '@mintdata/mint-kit/impl/components/popover/PopupTypes';
import {IdUtil} from '@mintdata/mint-kit/impl/util/IDUtil';
import {IStyles} from '@mintdata/mint-kit/impl/util/Styles';
import * as classnames from 'classnames/bind';
import * as React from 'react';

const styles = require('./DotsMenu.less');
const cx = classnames.bind(styles);

export enum DotsMenuSide
{
    BottomRight,
    BottomLeft,
    TopRight,
    TopLeft
}

export interface DotsMenuState
{
    isOpen:boolean;
}

export interface DotsMenuProps
{
    className?:string;
    popupClassName?:string;
    menuItems:Array<IContextMenuItem>;
    side?:DotsMenuSide;
    iconSize?:MDIconSize;
}

export class DotsMenu extends React.Component<DotsMenuProps, DotsMenuState>
{
    private _contextMenuTriggerId:string = IdUtil.newComponentId();

    constructor(props)
    {
        super(props);

        this.state = {
            isOpen: false,
        };
    }

    private static _renderItem(data:IContextMenuItem, state:IListItemState, styles:IStyles):JSX.Element
    {
        const menuItem:MenuItem = (data as any);
        const Renderer:AMenuItemRenderer = menuItem.renderer;

        return <Renderer menuItem={menuItem} />;
    }

    _computePopupConfig(side:DotsMenuSide):{sourceAnchor:SourceAnchor, popupAnchor:PopupAnchor}
    {
        let sourceAnchor:SourceAnchor;
        let popupAnchor:PopupAnchor;

        switch( side )
        {
            case DotsMenuSide.BottomLeft:
                sourceAnchor = SourceAnchor.RightBottom;
                popupAnchor = PopupAnchor.RightTop;
                break;
            case DotsMenuSide.BottomRight:
                sourceAnchor = SourceAnchor.LeftBottom;
                popupAnchor = PopupAnchor.LeftTop;
                break;
            case DotsMenuSide.TopLeft:
                sourceAnchor = SourceAnchor.LeftTop;
                popupAnchor = PopupAnchor.RightBottom;
                break;
            case DotsMenuSide.TopRight:
                sourceAnchor = SourceAnchor.RightTop;
                popupAnchor = PopupAnchor.LeftBottom;
                break;
        }

        return {sourceAnchor, popupAnchor};
    }

    private onShow = () =>
    {
        this.setState({isOpen: true});
    };

    private onHide = () =>
    {
        this.setState({isOpen: false});
    };

    render()
    {
        const {isOpen} = this.state;

        const {
            menuItems,
            className = '',
            popupClassName,
            side = DotsMenuSide.BottomLeft,
            iconSize,
        } = this.props;

        const cfg = this._computePopupConfig(side);

        const itemRenderer = menuItems.every(item => (item as any).renderer)
            ? DotsMenu._renderItem
            : undefined;

        return (
            <div
                className={`${cx('base', {isOpen})} ${className}`}
                id={this._contextMenuTriggerId}
            >
                <ContextMenu
                    className={styles.contextMenu}
                    popupClassName={cx(popupClassName)}
                    toggleOn={[ToggleOn.CLICK]}
                    togglersIds={[this._contextMenuTriggerId]}
                    popupAnchor={cfg.popupAnchor}
                    sourceAnchor={cfg.sourceAnchor}
                    itemRenderer={itemRenderer}
                    dataSource={() => menuItems}
                    onShow={this.onShow}
                    onHide={this.onHide}
                >
                    <MDIcon
                        className={cx('menuIcon')}
                        size={iconSize}
                        name={MDIcons.common.ThreeDotsVert}
                    />

                </ContextMenu>
            </div>
        );
    }
}
